var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.1 143.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "cls-1",
    d: "M60.6,123.9h0c-.2-.3-.4-.7-.6-1-2.9-5.5-3.8-11.9-2.5-18,2.3-11.2,3.3-26.1,1-38.9-2.3-12.7-6.9-21.8-3.9-33.9.3.1.6.2.9.2,1.8.2,3.4-1.1,3.6-2.9.2-1.8-1.1-3.4-2.9-3.6-1.8-.2-3.4,1.1-3.6,2.9-.1,1,.2,1.9.9,2.6-.7,2.3-3,11.9.8,34.8,0,0-11.4-23.5-25.7-36.5-6.1-5.6-7.6-13.1-8-16.8.2,0,.4,0,.6.1,3.6.4,6.8-2.2,7.2-5.8.4-3.6-2.2-6.8-5.8-7.2-3.6-.4-6.8,2.2-7.2,5.8-.3,2.8,1.2,5.5,3.9,6.7.5,5.2,3.1,14.6,12.9,27.7,12.8,17.1,16.8,29.5,16.8,29.5,0,0-8.6-11.3-20.3-18.3-11.4-6.8-22.1-9.9-24.7-22,.1,0,.3,0,.4,0,2.7.3,5.2-1.7,5.5-4.5s-1.7-5.2-4.5-5.5S.3,21.4,0,24.1c-.2,1.9.8,3.8,2.4,4.8.9,4.3,2.9,8.2,5.7,11.6,12.2,13.6,40.7,36.2,43.3,47.1,3.4,14.2.8,21.6-11,31.9h0c-5.9,4.5-7,12.9-2.5,18.8,4.5,5.9,12.9,7,18.8,2.5,5.2-4,6.8-11.1,3.7-16.9M59.2,131.1c-.5,5.8-5.7,10.1-11.5,9.6-5.8-.5-10.1-5.7-9.6-11.5.5-5.8,5.7-10.1,11.5-9.6,2.6.2,5.1,1.5,6.9,3.4,2,2.2,3,5.1,2.7,8.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDgWhite);
export default __webpack_public_path__ + "static/media/logo-dg-white.35ca75767bb706a7f860ac267dfb6877.svg";
export { ForwardRef as ReactComponent };